export const localStorageKeys = {
  ACCESS_TOKEN: "accessToken",
  LANGUAGE_DISPLAY: "languageDisplay",
  DISPLAY_VIEW: "displayView",
  DOWNLOAD_OPTIONS: "downloadOptions",
};
